import { createI18n } from "vue-i18n"
import en_US from "~/locales/en_US.json"
import zh_CN from "~/locales/zh_CN.json"
import fr_FR from "~/locales/fr_FR.json"
import ar_AE from "~/locales/ar_AE.json"
import ru_RU from "~/locales/ru_RU.json"
import es_ES from "~/locales/es_ES.json"

const messages = { en_US, zh_CN, fr_FR, ar_AE, ru_RU, es_ES }

export default defineNuxtPlugin(({ vueApp }) => {
    let lang = useCookie("lang")
    let locale = lang.value ? lang.value : 'zh_CN'
    if(!lang.value){
      lang.value = locale
    }
    const i18n = createI18n({
      locale, // 当前语言类型
      legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
      globalInjection: true, // 全局注册$t方法
      messages, // 语言包
    })
    vueApp.use(i18n)
  })